
// For Callcenter and Customer For Live`

const BASE_URL = "https://retailportalapi.webddocsystems.com/";
const ChargingBASE_URL = "https://chargingapi.webddocsystems.com/";
const paybridge_Url = "https://paybridge-backend.webddocsystems.com/api/";




//// For Finance and Reversal Testing

// const BASE_URL = "http://localhost:5045/";
// const ChargingBASE_URL = "https://localhost:7244/";
// const paybridge_Url = "http://localhost:5000/api/";




export { BASE_URL ,ChargingBASE_URL,paybridge_Url };